export const SEARCH_CHARS_MIN_LIMIT = 3
export const SEARCH_CHARS_MAX_LIMIT = 50
export const SEARCH_RESULTS_LIMIT = 10
